import { Pipe, PipeTransform } from '@angular/core';
import { NavigationItem } from '../../models/bar.type';

@Pipe({ name: 'navigationCategories' })
export class NavigationCategoryPipe implements PipeTransform {
    transform(
        navigationItems: NavigationItem[] | undefined
    ): { category: string; navigationItems: NavigationItem[] }[] | undefined {
        if (!navigationItems) return undefined;

        const GROUPED: { [key: string]: NavigationItem[] } = navigationItems.reduce(
            // @ts-ignore
            (r, v, i, a, k = v.category) => ((r[k] || (r[k] = [])).push(v), r),
            {}
        );

        return Object.keys(GROUPED).map((key: string) => {
            return { category: key, navigationItems: GROUPED[key] };
        });
    }
}
